import {useState, useEffect} from 'react';
import axios from 'axios';
import DatePicker, {DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import '../../Styles/Components/Persons/Preview_Person.css';
import Dialog_alert from '../PublicForms/Dialog_alert.js';
import {useNavigate, useParams } from "react-router-dom";
import Config from '../PublicForms/Config.js';
import isTokenExpired from '../PublicForms/isTokenExpired.js';
import Header from '../PublicForms/Header.js';
import Navigation_Bar from '../PublicForms/Navigation_Bar.js';
import { ScrollToTop } from '../PublicForms/ScrollToTop.js';




export default function Preview_SubDetails() {

  const{personID,subscriptID} = useParams();
  const[openNav, setOpenNav] = useState(true);
  const[runOpen, setRunOpen] = useState(false);
  const[loading , setLoading] = useState(false);
  const[subscriptIDState, setSubscriptIDState] = useState(subscriptID);
  const[which, setWhich] = useState(subscriptID.includes(undefined) ? "Add": "Edit");
  const[runUseEffect, setRunUseEffect] = useState(subscriptID.includes(undefined) ? false : true);
  const[runSaveData, setRunSaveData] = useState(false);
  const[runEditData, setRunEditData] = useState(false);
  const[runDelData, setRunDelData] = useState(false);
  const[data, setData] = useState([]);
  const[message, setMessage] = useState([]);
  const[messTitle, setMessTitle] = useState("");
  const[showDialog, setShowDialog] = useState(false);
  const[width, setWidth] = useState(0);
  const Navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem('token')) {
      const token = localStorage.getItem('token');
      if (isTokenExpired(token)) {
        localStorage.removeItem('token');
        Navigate("/login");
      } else {
        // setUser(JSON.parse(localStorage.getItem('user')));
      }
    } else {
        Navigate("/login");
    }
  }, []);
  
  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth)
    }
    
    window.addEventListener("resize", handleResize)
    
    handleResize()
    
    
  }, []);

  useEffect(()=>
    {
  
    },[runOpen])

  var validData = 0;
 
 

  const setValueData = (val, indx) =>
  {

    var arr = data;

    arr[indx] = val;

    setData(arr);
    if(indx == 0)
    {
      var arr = data;

      arr[4] = val;

      setData(arr);
    }

    if(indx == 2)
      {
        var arr = data;
  
        arr[3] = val;
  
        setData(arr);
      }
    

  }


  const checkValidData = ()=>
  {
    validData = 0;

    if(data[0] === undefined || data[0] === null ||  data[0] === "")
    {
      setMessTitle("توجه");
      var mess = "لطفا طول دوره اشتراک را وارد کنید";
      var tempArr = message;
      tempArr.push(mess);
      setMessage(tempArr);    
    }else
    {
      validData = validData +1;

    }

    if(data[1] === undefined || data[1] === null ||  data[1] === "")
      {
        setMessTitle("توجه");
        var mess = " لطفا تاریخ شروع را وارد کنید";
        var tempArr = message;
        tempArr.push(mess);
        setMessage(tempArr);    
      }else
      {
        validData = validData +1;

      }
   

    if(data[2] === undefined || data[2] === null || data[2] === "")
    {
      setMessTitle("توجه");
      var mess = " لطفا مبلغ پرداختی را وارد کنید";
      var tempArr = message;
      tempArr.push(mess);
      setMessage(tempArr);
      
    }else
    {
      validData = validData +1;

    }
    
    if(which == "Edit")
    {

      if(data[3] === undefined || data[3] === null || data[3] === "")
        {
          setMessTitle("توجه");
          var mess = "موجودی نباید بدون مقدار باشد";
          var tempArr = message;
          tempArr.push(mess);
          setMessage(tempArr);
          setShowDialog(true);
        }else
        {
          validData = validData +1;
    
        }   

        if(data[4] === undefined || data[4] === null || data[4] === "")
        {
          setMessTitle("توجه");
          var mess = "تعداد ماه باقی مانده نباید بدون مقدار باشد";
          var tempArr = message;
          tempArr.push(mess);
          setMessage(tempArr);
          setShowDialog(true);
        }else
        {
          validData = validData +1;
    
        }   
      
    }

    if(data[5] === undefined || data[5] === null || data[5] === "")
    {
      setMessTitle("توجه");
      var mess = "فیلد تعداد اشتراک نباید بدون مقدار باشد";
      var tempArr = message;
      tempArr.push(mess);
      setMessage(tempArr);
      setShowDialog(true);
    }else
    {
      validData = validData +1;

    }   

  if(which === "Add" && validData === 4)
  {
    setRunSaveData(true);

  }else if(which === "Add" && validData !== 4)
  {

    setShowDialog(true);
    
  }       
  
  if(which === "Edit" && validData === 6)
    {
      setRunEditData(true);

    }else if(which === "Edit" && validData !== 6)
    {
  
      setShowDialog(true);
      
    }       
  
  

  }

  useEffect(()=>
 {
    const fetchDetail = async () => {
        setLoading(true);
        axios.get(`${Config.apiBaseUrl}/api/SubscriptDetails/${subscriptIDState}/true`,{headers: {
         
          "Authorization":`Bearer ${localStorage.getItem('token')}`,
        }
      }).then(response => 
        {

            if(response.status === 200)
            {
              setData(oldArr=>[...oldArr,(response.data.detailsDuration)+""]);
              setData(oldArr=>[...oldArr,response.data.startDate]);
              setData(oldArr=>[...oldArr,(response.data.total)+""]);
              setData(oldArr=>[...oldArr,(response.data.remainAmount)+""]);
              setData(oldArr=>[...oldArr,(response.data.remainMonth)+""]);
              setData(oldArr=>[...oldArr,(response.data.number)+""]);
              setData(oldArr=>[...oldArr,response.data.lastVersion == null ? "---" : (response.data.lastVersion)+""]);
              setData(oldArr=>[...oldArr,response.data.detailsDescript == null ? "---" : response.data.detailsDescript]);
             
                    
            }else
            {
              setMessTitle("خطا");
              setMessage((prevMessages) => {
                  return [
                      ...prevMessages, // shallow copy into new array reference
                      "برقراری ارتباط با سرور مقدور نمی باشد، لطفا مجددا تلاش کنید",      // append new element
                  ];
              });                
              
              setShowDialog(true);
            }

        }).catch((err) =>{

          if(err.response !== null && err.response !== undefined)
            {
                setMessage([]);
                if(err.response.status === 401)
                {
                    Navigate("/login");
                }else if((err.response.status) === 500)
                {
                    setMessTitle("خطا");
                    setMessage((prevMessages) => {
                        return [
                            ...prevMessages, // shallow copy into new array reference
                            (err.response.detail),      // append new element
                        ];
                    });
                    setShowDialog(true);
    
                }else
                {
                    setMessTitle("خطا");
                    setMessage((prevMessages) => {
                        return [
                            ...prevMessages, // shallow copy into new array reference
                            "لطفا مجددا تلاش کنید",      // append new element
                        ];
                    });
                    setShowDialog(true);
        
                }
    
            }else if(err.message == "Network Error")
            {
                setMessTitle("خطا");
                setMessage((prevMessages) => {
                    return [
                        ...prevMessages, // shallow copy into new array reference
                        "برقراری ارتباط با سرور امکان پذیر نمی باشد",      // append new element
                    ];
                });
                setShowDialog(true);
            }else
            {
            setMessTitle("خطا");
            setMessage((prevMessages) => {
                return [
                    ...prevMessages, // shallow copy into new array reference
                    ("لطفا مجددا تلاش کنید"),      // append new element
                ];
            });                
            
            setShowDialog(true);
            }
            
        })
        setRunUseEffect(false);
        setLoading(false);
    }
    if(runUseEffect == true)
    {
        fetchDetail();

    }

    },[runUseEffect])

  useEffect(()=>
  {
    
    const saveData = async ()=>
    {
      axios.post(
        `${Config.apiBaseUrl}/api/SubscriptDetails`,{

          "detailsDuration": parseInt(data[0]),
          "startDate": data[1],
          "total": parseFloat(data[2]),
          "remainAmount": parseFloat(data[2]),
          "remainMonth": parseInt(data[0]),
          "number": parseInt(data[5]),
          "lastVersion": data[6],
          "detailsDescript": data[7] !== undefined && data[7] !== null && data[7] !== ""? data[7] : "---",
          "personID": personID        
        
        },{headers: {
         
          "Authorization":`Bearer ${localStorage.getItem('token')}`,
        }
      }).then(response => 
      {
        console.log(response)
          if(response.status == 201)
          {
              setSubscriptIDState(response.data.detailsID);
              setMessTitle("توجه");
              setMessage((prevMessages) => {
                  return [
                    ...prevMessages, // shallow copy into new array reference
                    "اطلاعات مورد نظر شما با موفقیت ثبت شد",      // append new element
                  ];
                });
              setShowDialog(true);
              setWhich("Edit")
            //  setRunChangeStatus(true);
  
          }else
          {
              setMessTitle("خطا");
              setWhich("Add")
              setMessage((prevMessages) => {
                  return [
                    ...prevMessages, // shallow copy into new array reference
                    "لطفا مجددا تلاش کنید",      // append new element
                  ];
              });
              setShowDialog(true);
          }
  
      }).catch((err) =>{
        console.log(err)
        setWhich("Add")
        if(err.response !== null && err.response !== undefined)
          {
                setMessage([]);
                if(err.response.status == 401)
                {
                    Navigate("/login");
    
    
                }else if((err.response.status)==500)
                {
                      setMessTitle("خطا");
                      setMessage((prevMessages) => {
                          return [
                              ...prevMessages, // shallow copy into new array reference
                              (err.response.data.detail),      // append new element
                          ];
                      });
                      setShowDialog(true);
          
                }else
                {
                        setMessTitle("خطا");
                        setMessage((prevMessages) => {
                            return [
                              ...prevMessages, // shallow copy into new array reference
                              "لطفا مجددا تلاش کنید",      // append new element
                            ];
                        });
                        setShowDialog(true);
        
                }
    
          }else if(err.message == "Network Error")
          {
                setMessTitle("خطا");
                        setMessage((prevMessages) => {
                            return [
                              ...prevMessages, // shallow copy into new array reference
                              "برقراری ارتباط با سرور امکان پذیر نمی باشد",      // append new element
                            ];
                        });
                        setShowDialog(true);
          }else
          {
                setMessTitle("خطا");
                setMessage((prevMessages) => {
                    return [
                        ...prevMessages, // shallow copy into new array reference
                        ("لطفا مجددا تلاش کنید"),      // append new element
                    ];
                });                
                
                setShowDialog(true);
          }   
          
     })
     setRunSaveData(false);
     setWhich("Edit")
    
    }
   
    const editData = async ()=>
    {

      axios.put(
        `${Config.apiBaseUrl}/api/SubscriptDetails/${subscriptIDState}?startDate=${data[1]}&DetailsDuration=${parseInt(data[0])}&Total=${parseFloat(data[2])}&RemainAmount=${parseFloat(data[3])}&RemainMonth=${parseInt(data[4])}&Number=${parseInt(data[5])}&LastVersion=${data[6]}&DetailsDescript=${data[7]}`,
        {},{headers: {
         
          "Authorization":`Bearer ${localStorage.getItem('token')}`,
        }
      }).then(response => 
      {
          if(response.status == 204)
          {

              setMessTitle("توجه");
              setMessage((prevMessages) => {
                  return [
                    ...prevMessages, // shallow copy into new array reference
                    "اطلاعات مورد نظر شما با موفقیت به روز شد",      // append new element
                  ];
                });
              setShowDialog(true);
  
          }else
          {
              setMessTitle("خطا");
              setMessage((prevMessages) => {
                  return [
                    ...prevMessages, // shallow copy into new array reference
                    "لطفا مجددا تلاش کنید",      // append new element
                  ];
              });
              setShowDialog(true);
          }
  
      }).catch((err) =>{
        setWhich("Add")

        if(err.response !== null && err.response !== undefined)
          {
                setMessage([]);
                if(err.response.status == 401)
                {
                    Navigate("/login");
    
    
                }else if((err.response.status)==500)
                {
                      setMessTitle("خطا");
                      setMessage((prevMessages) => {
                          return [
                              ...prevMessages, // shallow copy into new array reference
                              (err.response.detail),      // append new element
                          ];
                      });
                      setShowDialog(true);
          
                }else
                {
                        setMessTitle("خطا");
                        setMessage((prevMessages) => {
                            return [
                              ...prevMessages, // shallow copy into new array reference
                              "لطفا مجددا تلاش کنید",      // append new element
                            ];
                        });
                        setShowDialog(true);
        
                }
    
          }else if(err.message == "Network Error")
          {
                setMessTitle("خطا");
                        setMessage((prevMessages) => {
                            return [
                              ...prevMessages, // shallow copy into new array reference
                              "برقراری ارتباط با سرور امکان پذیر نمی باشد",      // append new element
                            ];
                        });
                        setShowDialog(true);
          }else
          {
                setMessTitle("خطا");
                setMessage((prevMessages) => {
                    return [
                        ...prevMessages, // shallow copy into new array reference
                        ("لطفا مجددا تلاش کنید"),      // append new element
                    ];
                });                
                
                setShowDialog(true);
          }
               
      })
      setRunEditData(false);
    }

    const deleteData = async ()=>
      {
        //0-fname, 1-lname, 2-bdate, 3-mobile, 4-home, 5-email, 6-city, 7-postal, 8-address, 9-descript
        axios.delete(
          `${Config.apiBaseUrl}/api/SubscriptDetails/${subscriptIDState}`,{headers: {
         
            "Authorization":`Bearer ${localStorage.getItem('token')}`,
          }
        }).then(response => 
        {
            if(response.status == 204)
            {
                setMessTitle("توجه");
                setMessage((prevMessages) => {
                    return [
                      ...prevMessages, // shallow copy into new array reference
                      "اطلاعات مورد نظر شما با موفقیت حذف شد",      // append new element
                    ];
                  });
                setShowDialog(true);

    
            }else
            {
                setMessTitle("خطا");
                setMessage((prevMessages) => {
                    return [
                      ...prevMessages, // shallow copy into new array reference
                      "لطفا مجددا تلاش کنید",      // append new element
                    ];
                });
                setShowDialog(true);
            }
    
        }).catch((err) =>{
          
          if(err.response !== null && err.response !== undefined)
            {
              setMessage([]);
              if(err.response.status == 401)
              {
                  Navigate("/login");
  
  
              }else if((err.response.status) === 400)
              {
                      setMessTitle("خطا");
                      setMessage((prevMessages) => {
                          return [
                            ...prevMessages, // shallow copy into new array reference
                            ("اطلاعات این کاربر قبلا حذف شده است."),      // append new element
                          ];
                      });
                      setShowDialog(true);
      
              }else
              {
                      setMessTitle("خطا");
                      setMessage((prevMessages) => {
                          return [
                            ...prevMessages, // shallow copy into new array reference
                            "لطفا مجددا تلاش کنید",      // append new element
                          ];
                      });
                      setShowDialog(true);
      
              }
      
            }else if(err.message == "Network Error")
            {
                setMessTitle("خطا");
                setMessage((prevMessages) => {
                    return [
                      ...prevMessages, // shallow copy into new array reference
                      "برقراری ارتباط با سرور امکان پذیر نمی باشد",      // append new element
                    ];
                });
                setShowDialog(true);
            }else
            {
                  setMessTitle("خطا");
                  setMessage((prevMessages) => {
                      return [
                          ...prevMessages, // shallow copy into new array reference
                          ("لطفا مجددا تلاش کنید"),      // append new element
                      ];
                  });                
                  
                  setShowDialog(true);
            }      
        })
    }

    if(runSaveData === true)
    {
      saveData();

    }else if(runEditData === true)
    {
      editData();
      
    }else if(runDelData)
    {
      deleteData();

    }

  },[runSaveData, runEditData, runDelData]);


  //message dialog
  const closeOpenDialog = (open) =>
  {

    setMessage([]);
    setShowDialog(false);
    if(runDelData)
    {
      setRunDelData(false);
      Navigate(`/subscripts/lstSubscripts/اشتراک/subScriptLst/${personID}/true/false`);


    }

          
  }


  
  const handleNave = ()=>
    {
      if(runOpen && openNav)
        {
          setOpenNav(false);
          setRunOpen(false);
        }else
        {
          setOpenNav(!openNav);
  
  
        }
        
  
    }

    const handleNaveForm = ()=>
      {
        if(!openNav)
          {
            setOpenNav(!openNav)
          }
      }

  if(width>999)
  {
        return (
          <div className='prevPerson' >



                <Header />

                <ScrollToTop />
                      
                <div className="navClass">
                        <Navigation_Bar />
                    
                </div>
                    

          
              <div className='prevPersonContainer'>
                
                  <div className='row'>

                  <div className='col-md-1'></div>

                  <div className='col-md-11 prevPersonForm'>
                    
                    <div className='row'>

                    <div className="col-md-4 form-group">
                          <label htmlFor="duration">طول دوره اشتراک &#9733;</label>
                          <input type="number" className="form-control" id="name" defaultValue={data[0]}  onChange={(e)=>setValueData(e.target.value,0)}  
                          onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}/>
                      </div>

                      <div className="col-md-4 form-group">
                          <div>
                          <label htmlFor="birthdate">تاریخ شروع ارسال &#9733;</label>

                          </div>
                          <div className="myContainer">

                          <DatePicker
                            
                              value={data[1]}
                              calendar={persian}
                              locale={persian_fa}
                              calendarPosition="bottom-right"
                              onChange = { e => setValueData(e.year+"/"+e.month+"/"+e.day,1)}

                            />
                            </div>
                      </div>              

                      <div className="col-md-4 form-group">
                          <label htmlFor="total">مبلغ پرداختی &#9733;</label>
                          <input type="number" className="form-control" id="total" defaultValue={data[2]} onChange={(e)=>{
                            setValueData(e.target.value,2)}}
                            onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}/>

                      </div>


                      <div className="col-md-4 form-group">
                          <label htmlFor="number">تعداد اشتراک مجله &#9733;</label>
                          <input type="number" className="form-control" id="number" defaultValue={data[5]}  onChange={(e)=>setValueData(e.target.value,5)} 
                              onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}/>
                      </div>

                      <div className="col-md-4 form-group">
                          <label htmlFor="descript">توضیحات</label>
                          <textarea type="text" rows="5" className="form-control" id="descript" defaultValue = {data[7]} onChange={(e)=>setValueData(e.target.value,7)}></textarea>

                      </div>

                      {which === "Edit" ?
                        <div className="col-md-4 form-group">
                          <label htmlFor="remain">موجودی &#9733;</label>
                          <input type="number" className="form-control" id="remain" defaultValue={data[3]} onChange={(e)=>setValueData(e.target.value,3)}
                              onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}/>

                        </div>
                        :
                        null
                      }  

                      {which === "Edit" ?
                        <div className="col-md-4 form-group">
                          <label htmlFor="remainMonth">تعداد ماه باقی مانده از اشتراک &#9733;</label>
                          <input type="number" className="form-control" id="remainMonth" defaultValue={data[4]} onChange={(e)=>setValueData(e.target.value,4)}
                              onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}/>

                        </div>
                        :
                        null
                      } 

                      {which === "Edit" ?
                        <div className="col-md-4 form-group">
                          <label htmlFor="lastV">آخرین نسخه ارسالی</label>
                          <input type="text" className="form-control" id="lastV" defaultValue={data[6]} onChange={(e)=>setValueData(e.target.value,6)}/>

                        </div>
                        :
                        null
                      } 
                      
                    </div>
                      
                    

                                                      
                  </div>
                  {showDialog ? <Dialog_alert show = {showDialog} closeOpenDialog = {closeOpenDialog} messTitle ={messTitle} message = {message}/> : null}

                  </div>

                
                  <div className='buttonContainer'>
                            <button  type='button' onClick={()=>{
                              setMessage([]);
                              checkValidData();
                            }} autoFocus>
                              {which === "Add" ? "ثبت" : "ویرایش"}
                            </button>
                            {
                              which === "Edit" ?
                                
                              <button  type='button' onClick={()=>Navigate(`/subscripts/printSubscript/اشتراک/printSubScript/${personID}/${subscriptIDState}/true/true`)} >
                                چاپ
                             </button> 
                             :
                             null
                            }
                
                            {
                              which === "Edit" ?
                                  
                                
                                <button  type='button' onClick={()=>setRunDelData(true)} >
                                      حذف
                                </button> 
                                    
                              : null
                            } 
                                
                               

                            </div>
              </div>
          </div>

      
    );
  }else
  {
    return (
      <div className='prevPerson-all-responsive'>


           <div className= {openNav? "navClass" : "navClass navClassOpen"}>  
                              

              <Navigation_Bar />
                                
           </div>
      <div className='prevPerson' >



            <Header handleNave={handleNave}/>

            <ScrollToTop />
                  
           
                

      
          <div className='prevPersonContainer' onClick={()=>handleNaveForm()}>
            
              <div className='row'>


              <div className='prevPersonForm'>
                
                <div className='row'>

                <div className="col-sm-6 col-md-4 form-group">
                      <label htmlFor="duration">طول دوره اشتراک &#9733;</label>
                      <input type="number" className="form-control" id="name" defaultValue={data[0]}  onChange={(e)=>setValueData(e.target.value,0)}  
                      onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}/>
                  </div>

                  <div className="col-sm-6 col-md-4 form-group">
                      <div>
                      <label htmlFor="birthdate">تاریخ شروع ارسال &#9733;</label>

                      </div>
                      <div className="myContainer">

                      <DatePicker
                        
                          value={data[1]}
                          calendar={persian}
                          locale={persian_fa}
                          calendarPosition="top-right"
                          onChange = { e => setValueData(e.year+"/"+e.month+"/"+e.day,1)}

                        />
                        </div>
                  </div>              

                  <div className="col-sm-6 col-md-4 form-group">
                      <label htmlFor="total">مبلغ پرداختی &#9733;</label>
                      <input type="number" className="form-control" id="total" defaultValue={data[2]} onChange={(e)=>{
                        setValueData(e.target.value,2)}}
                        onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}/>

                  </div>


                  <div className="col-sm-6 col-md-4 form-group">
                      <label htmlFor="number">تعداد اشتراک &#9733;</label>
                      <input type="number" className="form-control" id="number" defaultValue={data[5]}  onChange={(e)=>setValueData(e.target.value,5)} 
                          onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}/>
                  </div>

                  <div className="col-sm-6 col-md-4 form-group">
                      <label htmlFor="descript">توضیحات</label>
                      <textarea type="text" rows="5" className="form-control" id="descript" defaultValue = {data[7]} onChange={(e)=>setValueData(e.target.value,7)}></textarea>

                  </div>

                  {which === "Edit" ?
                    <div className="col-sm-6 col-md-4 form-group">
                      <label htmlFor="remain">موجودی &#9733;</label>
                      <input type="number" className="form-control" id="remain" defaultValue={data[3]} onChange={(e)=>setValueData(e.target.value,3)}
                          onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}/>

                    </div>
                    :
                    null
                  }  

                  {which === "Edit" ?
                    <div className="col-sm-6 col-md-4 form-group">
                      <label htmlFor="remainMonth">تعداد ماه باقی مانده &#9733;</label>
                      <input type="number" className="form-control" id="remainMonth" defaultValue={data[4]} onChange={(e)=>setValueData(e.target.value,4)}
                          onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}/>

                    </div>
                    :
                    null
                  } 

                  {which === "Edit" ?
                    <div className="col-sm-6 col-md-4 form-group">
                      <label htmlFor="lastV">آخرین نسخه ارسالی</label>
                      <input type="text" className="form-control" id="lastV" defaultValue={data[6]} onChange={(e)=>setValueData(e.target.value,6)}/>

                    </div>
                    :
                    null
                  } 
                  
                </div>
                  
                

                                                  
              </div>
              {showDialog ? <Dialog_alert show = {showDialog} closeOpenDialog = {closeOpenDialog} messTitle ={messTitle} message = {message}/> : null}

              </div>

            
              <div className='buttonContainer'>

                
                           <button  type='button' onClick={()=>{
                              setMessage([]);
                              checkValidData();
                            }} autoFocus>
                              {which === "Add" ? "ثبت" : "ویرایش"}
                            </button>
                            {
                              which === "Edit" ?
                               <button type='button' onClick={()=>Navigate(`/subscripts/printSubscript/اشتراک/printSubScript/${personID}/${subscriptIDState}/true/true`)}>چاپ</button> :null
                            }
                            {
                              which === "Edit" ?
                                
                                  <button  type='button' onClick={()=>setRunDelData(true)} >
                                       حذف
                                  </button> 
                                    
                                
                              : null
                            } 
              
              </div>

                            
                           


          </div>
      </div>

      </div>

  
);
  }
 
   

}


 
